import { jsx as _jsx } from "react/jsx-runtime";
import { Container as MantineContainer } from '@mantine/core';
import { useXenTheme } from '../xen-theme-provider';
export const Container = (props) => {
    const { other: { maxContentWidth: defaultSize }, } = useXenTheme();
    return _jsx(MantineContainer, { size: defaultSize, ...props });
};
